import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  icon?: boolean;
  isBlack?: boolean;
  className?: string;
}

const PrimaryButton = ({
  className,
  children,
  icon,
  isBlack,
  ...props
}: ButtonProps) => {
  return (
    <button
      className={`text-lg jost-regular py-3 px-4 group hover:!-translate-y-1 flex justify-center items-center gap-4 transition-all duration-200 text-white bg-primary rounded-full hover:shadow-none focus:outline-none focus:ring-0 disabled:opacity-50 ${
        className ? className : ""
      }`}
      {...props}
    >
      {children}
      {icon && (
        <span className="group-hover:rotate-45 transition-all duration-300">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="33"
            viewBox="0 0 33 33"
            fill="none"
          >
            <path
              d="M16.3324 2H16.1929C8.19771 2 1.71631 8.4814 1.71631 16.4766C1.71631 24.4718 8.19771 30.9532 16.1929 30.9532H16.3324C24.3276 30.9532 30.809 24.4718 30.809 16.4766C30.809 8.4814 24.3276 2 16.3324 2Z"
              stroke={isBlack ? "#0d9447" : "white"}
              stroke-width="1.31958"
            />
            <path
              d="M11.3579 21.452L21.1682 11.5012M21.1682 11.5012H12.7591M21.1682 11.5012V20.0505"
              stroke={isBlack ? "#0d9447" : "white"}
              stroke-width="1.31958"
            />
          </svg>
        </span>
      )}
    </button>
  );
};

export default PrimaryButton;
